export default __webpack_public_path__ + "static/header.stadtamthall-3e86c3651916a19d1a7084ea112c676d.jpg";